/**
 * Sleeve Stars — Compare-table runtime fixes (SAFE BASELINE).
 * Source code for the .ss-pc__cv-* compare table lives in the unread tail of
 * sleevestars-pdp-visuals.js. This file ONLY does two safe patches:
 *   1. Hide any orphan mark cell beyond the label count in --ours / --theirs cols
 *   2. Swap the "Breathable knit" icon  → airflow SVG
 *   3. Swap the "Machine-washable" icon → washing-machine SVG
 *
 * Per-product row rewriting was attempted in a previous version but produced
 * appended-text and oversized-SVG bugs (labels stacked outside the card,
 * giant X covering Others column). That logic has been removed pending a
 * proper code review + verified DOM structure capture.
 */
(function () {
  'use strict';

  var BREATH_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8h11a3 3 0 1 0-3-3"/><path d="M3 13h15a3 3 0 1 1-3 3"/><path d="M3 18h8"/></svg>';
  var WASH_SVG   = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="3" width="16" height="18" rx="2"/><circle cx="12" cy="13" r="5"/><circle cx="8" cy="6" r=".5" fill="currentColor"/></svg>';

  function hardHide(el) {
    if (!el) return;
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('height', '0', 'important');
    el.style.setProperty('min-height', '0', 'important');
    el.style.setProperty('max-height', '0', 'important');
    el.style.setProperty('padding', '0', 'important');
    el.style.setProperty('margin', '0', 'important');
    el.style.setProperty('border', '0', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
    el.setAttribute('aria-hidden', 'true');
    el.dataset.ssHidden = '1';
  }

  function getAttrRowCount() {
    var candidates = [
      '.ss-pc__cv-col--attr .ss-pc__cv-cell',
      '.ss-pc__cv-col--attr .ss-pc__cv-attrcell',
      '.ss-pc__cv-col--attr > *'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var nodes = document.querySelectorAll(candidates[i]);
      if (nodes.length > 0) {
        var visible = 0;
        var hasTopSpacer = false;
        nodes.forEach(function (n, idx) {
          var hasContent = (n.textContent || '').trim().length > 0 || n.querySelector('svg, img');
          if (hasContent) {
            visible++;
            return;
          }
          // Keep the intentional first spacer row used to align against
          // the two branded header columns.
          if (idx === 0 && n.classList && n.classList.contains('ss-pc__cv-cell') && n.getAttribute('aria-hidden') === 'true') {
            hasTopSpacer = true;
          }
        });
        if (visible > 0) return visible + (hasTopSpacer ? 1 : 0);
      }
    }
    return 8;
  }

  function hideOrphanMarkCells() {
    var attrCount = getAttrRowCount();
    var cols = document.querySelectorAll('.ss-pc__cv-col--ours, .ss-pc__cv-col--theirs');
    cols.forEach(function (col) {
      var cells = col.querySelectorAll('.ss-pc__cv-mark-cell, .ss-pc__cv-markcell');
      if (!cells.length) {
        cells = col.querySelectorAll('.ss-pc__cv-cell');
      }
      for (var i = attrCount; i < cells.length; i++) {
        hardHide(cells[i]);
      }
    });
  }

  function swapIcons() {
    var cells = document.querySelectorAll('.ss-pc__cv-col--attr .ss-pc__cv-cell, .ss-pc__cv-col--attr .ss-pc__cv-attrcell, .ss-pc__cv-cell:not(.ss-pc__cv-mark-cell):not(.ss-pc__cv-markcell)');
    cells.forEach(function (cell) {
      if (cell.dataset.ssIconFixed === '1') return;
      var txt = (cell.textContent || '').trim().toLowerCase();
      var existing = cell.querySelector('svg');
      if (!existing) return;
      if (txt.indexOf('breathable') !== -1) {
        existing.outerHTML = BREATH_SVG;
        cell.dataset.ssIconFixed = '1';
      } else if (txt.indexOf('machine') !== -1 || (txt.indexOf('wash') !== -1 && txt.indexOf('able') !== -1)) {
        existing.outerHTML = WASH_SVG;
        cell.dataset.ssIconFixed = '1';
      }
    });
  }

  function fixAll() {
    try { hideOrphanMarkCells(); } catch (e) {}
    try { swapIcons(); } catch (e) {}
  }

  function init() {
    fixAll();
    setTimeout(fixAll, 250);
    setTimeout(fixAll, 800);
    setTimeout(fixAll, 1800);
    setTimeout(fixAll, 3500);

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.matches && (node.matches('[class*="ss-pc__cv"]') || node.querySelector('[class*="ss-pc__cv"]'))) {
              fixAll();
              return;
            }
          }
        }
      });
      mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', fixAll);
})();
